import { Validator, rules } from "@lchemy/model/validation";
import { SetPasswordCmd } from "@local/app/models";
import { complexityRule } from "./shared";

export interface ResetPasswordCmd {
  email: string;
  password: string;
  passwordConfirm: string;
  resetToken: string;
}

export const resetPasswordCmdValidator: Validator<ResetPasswordCmd> = new Validator<
  ResetPasswordCmd
>({
  email: [rules.required(), rules.isString(), rules.isEmail()],
  password: [rules.required(), complexityRule],
  passwordConfirm: [
    rules.required(),
    (confirm, model) => (confirm === model.password ? null : { confirm: true })
  ],
  resetToken: [rules.required(), rules.isString(), rules.minLength(1)]
});

export const recaptchaSetPasswordValidator = resetPasswordCmdValidator.extend<
  SetPasswordCmd & { recaptchaResponse: string }
>({
  recaptchaResponse: {
    nullable: true,
    check: (response) =>
      response == null || response.length === 0
        ? { reCaptchaResponseRequired: true }
        : null
  }
});
